import {Injectable} from "@angular/core";
import {QuestionState, CompletionState, RecordingBadge} from "./usermodel.objects";
import {UserModelService} from "./usermodel.service";


@Injectable()
export class UserProgress  {

    private transitionActive: boolean = false;

    constructor(private userModelService: UserModelService) {}

    public hasCompletedAllSteps(): boolean {
        return this.userModelService.taqCompletionState === CompletionState.COMPLETED &&
               this.userModelService.quizCompletionState === CompletionState.COMPLETED &&
               this.userModelService.recordCompletionState === CompletionState.COMPLETED;
    }

    public hasCompletedPreviewStep(): boolean {
        return this.userModelService.taqCompletionState === CompletionState.COMPLETED;
    }

    public hasCompletedQuizStep(): boolean {
        return this.userModelService.quizCompletionState === CompletionState.COMPLETED;
    }

    public getAnsweredPreviewQuestionCount(): number {
        let questionStates: {id: string, status: QuestionState}[] = this.userModelService.thinkAboutQuestionStates;
        return this.getAnsweredCount(questionStates);
    }

    public getAnsweredQuizQuestionCount(): number {
        let questionStates: {id: string, status: QuestionState}[] = this.userModelService.quizQuestionStates;
        return this.getAnsweredCount(questionStates);
    }

    public getCorrectPreviewQuestionCount(): number {
        let questionStates: {id: string, status: QuestionState}[] = this.userModelService.thinkAboutQuestionStates;
        return this.getCorrectCount(questionStates);
    }

    public getCorrectQuizQuestionCount(): number {
        let questionStates: {id: string, status: QuestionState}[] = this.userModelService.quizQuestionStates;
        return this.getCorrectCount(questionStates);
    }

    private getAnsweredCount(questionStates: {id: string, status: QuestionState}[]): number {
        let count: number = 0;
        for (let i: number = 0; i < questionStates.length; i++) {
            if (questionStates[i].status === QuestionState.ANSWERED_CORRECTLY || questionStates[i].status === QuestionState.ANSWERED_INCORRECTLY) {
                count += 1;
            }
        }
        return count;
    }

    private getCorrectCount(questionStates: {id: string, status: QuestionState}[]): number {
        let count: number = 0;
        for (let i: number = 0; i < questionStates.length; i++) {
            if (questionStates[i].status === QuestionState.ANSWERED_CORRECTLY) {
                count += 1;
            }
        }
        return count;
    }

    public getRecordingPointCheck(): boolean {
        let recordingPoint: number = this.userModelService.recordingPoint;
        return recordingPoint >= 75 && recordingPoint < 100;
    }

    public hasRecordedTwoTimes(): boolean {
        return this.userModelService.recordCount === 2;
    }

    public hasRecordedThreeTimes(): boolean {
        return this.userModelService.recordCount > 2;
    }

    public hasSufficientPercentageOfMaxPoints(): boolean {
        let storyPoints: number = this.userModelService.totalPoint / this.userModelService.storyTotalPoint * 100;
        if (storyPoints > 75) {
            return true;
        } else {
            return false;
        }
    }

    public hasSilverRecordingStar(): boolean {
        return this.userModelService.recordingBadge === RecordingBadge.SILVER;
    }

    public isTransitionActive(): boolean {
        return this.transitionActive;
    }

    public setTransitionActive(active: boolean) {
        this.transitionActive = active;
    }

}
